import axios from 'axios';

class AuthProvider {
    constructor(url) {
        this.url = url;
    }

    login(username, password) {
        return axios.post(`${this.url}/auth/login/ldap`, {'login': username, 'password': password}).then((response) => {
            const accessToken = response.data.token.accessToken;
            const refreshToken = response.data.token.refreshToken;
            return new Promise((resolve) => {
                resolve({
                    'accessToken': accessToken,
                    'refreshToken': refreshToken
                });
            });
        }).catch((error) => {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        });
    }

    validate(accessToken) {
        return axios.post(`${this.url}/auth/validate`, {'accessToken': accessToken});
    }

    refresh(refreshToken) {
        return axios.post(`${this.url}/auth/refresh`, {'refreshToken': refreshToken});
    }
}

const getAuthProvider = (url) => {
    return new AuthProvider(url);
}

export { getAuthProvider };